import $ from "jquery";

$(document).ready(() => {
    // Venue Add to/Remove from favorites begins here
    $('body').on('click', '.venue-toggle-favorite-button', (event) => {
        const $el = $(event.currentTarget);
        const $i = $el.find('i:first');
        const $txt = $el.find('.txt:first');
        const venueId = $el.data('venue-id');
        const isFavoriteClass = $el.data('is-favorite-class');
        const notFavoriteClass = $el.data('not-favorite-class');
        const addFavoriteText = $el.data('add-favorite-txt');
        const removeFavoriteText = $el.data('remove-favorite-txt');
        const currentlyIsFavorite = $i.hasClass(isFavoriteClass);
        window.CS.API.apiAjaxRequest('/favorite-venues', {
            data: {venue_id: venueId},
            method: currentlyIsFavorite ? 'DELETE' : 'POST'
        }).done(() => {
            const addedToFavorites = !currentlyIsFavorite;
            $i.toggleClass(isFavoriteClass + ' ' + notFavoriteClass);
            $txt.text(addedToFavorites ? removeFavoriteText : addFavoriteText);
        });
    });
});
